import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const BATCH_API_URL = `${process.env.REACT_APP_BATCH_API_URL}/api`;

// Headers de rate limit que queremos capturar
const RATE_LIMIT_HEADERS = [
  'x-daily-requests-left',
  'x-daily-usage',
  'x-hourly-requests-left',
  'x-hourly-usage',
  'x-minute-requests-left',
  'x-minute-usage',
  'x-rate-limit-daily',
  'x-rate-limit-hourly',
  'x-rate-limit-minute'
];

// Estado local de los rate limits
let currentRateLimits = {};

const apiService = {
  // Método para obtener los rate limits actuales
  getCurrentRateLimits: () => ({ ...currentRateLimits }),

  // Método para actualizar los rate limits
  updateRateLimits: (headers) => {
    RATE_LIMIT_HEADERS.forEach(header => {
      const value = headers[header];
      if (value) {
        currentRateLimits[header] = value;
      }
    });
  },

  get: async (url) => {
    try {
      console.log(`Realizando petición GET a: ${API_URL}${url}`);
      const response = await axios.get(`${API_URL}${url}`);
      console.log(`Respuesta GET de ${url}:`, response);
      
      // Capturar headers de rate limit
      apiService.updateRateLimits(response.headers);
      
      // Para endpoints que devuelven directamente un array o valor primitivo
      if (url.includes('/filters')) {
        return response;
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error en petición GET a ${url}:`, error);
      
      // Capturar headers de rate limit incluso en caso de error
      if (error.response) {
        apiService.updateRateLimits(error.response.headers);
      }
      
      const errorMessage = error.response?.data?.message || error.message;
      const errorDetails = error.response?.data?.details || error.response?.data?.stackTrace;
      
      // Log detallado del error
      if (error.response) {
        console.error('Error response status:', error.response.status);
        console.error('Error response data:', error.response.data);
      } else if (error.request) {
        console.error('Error request:', error.request);
      } else {
        console.error('Error message:', error.message);
      }
      
      throw {
        message: errorMessage,
        details: errorDetails,
        status: error.response?.status,
        response: error.response
      };
    }
  },

  post: async (url, data) => {
    try {
      console.log(`Realizando petición POST a: ${API_URL}${url} con datos:`, data);
      const response = await axios.post(`${API_URL}${url}`, data);
      console.log(`Respuesta POST de ${url}:`, response);
      
      // Capturar headers de rate limit
      //apiService.updateRateLimits(response.headers);
      
      // For 207 Multi-Status, we want to return the full response, not just data
      if (response.status === 207) {
        return response.data;
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error en petición POST a ${url}:`, error);
      
      // Capturar headers de rate limit incluso en caso de error
      if (error.response) {
        apiService.updateRateLimits(error.response.headers);
      }
      
      // Special handling for 207 Multi-Status which might be caught as an error
      if (error.response?.status === 207) {
        return error.response.data;
      }
      
      // Handle both string and object error responses
      const errorMessage = typeof error.response?.data === 'string' 
        ? error.response.data 
        : error.response?.data?.message || error.message;
      
      const errorDetails = typeof error.response?.data === 'object' 
        ? error.response?.data?.details || error.response?.data?.stackTrace 
        : undefined;

      console.error('Error details:', {
        message: errorMessage,
        details: errorDetails,
        status: error.response?.status,
        data: error.response?.data
      });

      throw {
        message: errorMessage,
        details: errorDetails,
        status: error.response?.status,
        response: error.response
      };
    }
  },

  put: async (url, data) => {
    try {
      const response = await axios.put(`${API_URL}${url}`, data);
      // Capturar headers de rate limit
      apiService.updateRateLimits(response.headers);
      return response;
    } catch (error) {
      // Capturar headers de rate limit incluso en caso de error
      if (error.response) {
        apiService.updateRateLimits(error.response.headers);
      }
      const errorMessage = error.response?.data?.message || error.message;
      const errorDetails = error.response?.data?.details || error.response?.data?.stackTrace;
      throw {
        message: errorMessage,
        details: errorDetails,
        status: error.response?.status,
        response: error.response
      };
    }
  },

  delete: async (url) => {
    try {
      const response = await axios.delete(`${API_URL}${url}`);
      // Capturar headers de rate limit
      apiService.updateRateLimits(response.headers);
      return response;
    } catch (error) {
      // Capturar headers de rate limit incluso en caso de error
      if (error.response) {
        apiService.updateRateLimits(error.response.headers);
      }
      const errorMessage = error.response?.data?.message || error.message;
      const errorDetails = error.response?.data?.details || error.response?.data?.stackTrace;
      throw {
        message: errorMessage,
        details: errorDetails,
        status: error.response?.status,
        response: error.response
      };
    }
  },

  batchPost: async (url, data) => {
    try {
      const response = await axios.post(`${BATCH_API_URL}${url}`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Batch API Error:', error);
      throw error;
    }
  }
};

export default apiService;